/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Uploading_LabelInputs */

const en_doc_uploading_label = /** @type {(inputs: Doc_Uploading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploading…`)
};

const pt_br2_doc_uploading_label = /** @type {(inputs: Doc_Uploading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando…`)
};

/**
* | output |
* | --- |
* | "Uploading…" |
*
* @param {Doc_Uploading_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_uploading_label = /** @type {((inputs?: Doc_Uploading_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Uploading_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_uploading_label(inputs)
	return pt_br2_doc_uploading_label(inputs)
});